<template>
  <span>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="cognitoErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        The administrator could not be removed from the authentication system.
        If the administrator is in Pending status, this may indicate the
        administrator was not yet present in the authentication system.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('cognitoErrorModal');
            $router.push('/usermanagement');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="inactiveSaveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Warning</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Did you intend to reactivate this administrator? Changes to inactive
        administrators will not be saved.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('inactiveSaveModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="insertUpdateErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        User ID '{{ form.email }}' is already active for another account.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('insertUpdateErrorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="insertDupErrorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        User ID '{{ form.email }}' already exists. Record will not be inserted.
        Please edit the existing admin to make updates.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('insertDupErrorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="saveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Submitted</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Your changes have been submitted for processing. Changes may take up to
        24 hours to go into effect.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="
            $modal.hide('saveModal');
            $router.push('/usermanagement');
          "
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="noChangesModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>No Updates Detected</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        <br />
        No updates were detected. Please make your edits and re-submit.
        <br />
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('noChangesModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <modal
      name="selectPermissionsModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Validation Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Please select at least one permission for the admin user.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#00558C"
          dark
          @click="$modal.hide('selectPermissionsModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <div ref="form" style="max-width: 1200px; margin: auto; margin-top: 100px">
      <v-card-title>
        <v-row>
          <v-col>
            <h2
              :class="
                $vuetify.breakpoint.smAndUp ? 'addressTitle' : 'addressTitleXS'
              "
            >
              <v-icon color="green" size="36">{{ isIAMAdmin ? 'mdi-lead-pencil' : 'mdi-magnify' }}</v-icon>&nbsp;

              <span v-if="isUpdate">{{ isIAMAdmin ? 'Update Admin User' : 'View Admin User' }}</span>
              <span v-else>Create Admin User</span>
            </h2>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text v-if="$vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col>
            <v-row class="littleDrop"> </v-row>
            <v-row v-if="isUpdate" class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="federationId"
                  v-model="federationIdLocal"
                  label="User ID"
                  outlined
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="isUpdate">
              <v-col>
                <v-text-field
                  ref="status"
                  v-model="statusLocal"
                  label="Admin User Status"
                  outlined
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  ref="activeStatusDate"
                  :value="activeStatusDateLocal | mmddyyyy"
                  label="Active Status Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  ref="inActiveStatusDate"
                  :value="inActiveStatusDateLocal | mmddyyyy"
                  label="Inactive Status Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-checkbox
                  v-if="
                    user.AgentAdminStatusCode == 'A' ||
                      user.AgentAdminStatusCode == 'P' ||
                      user.AgentAdminStatusCode == 'F'
                  "
                  color="green"
                  label="Disable User Access?"
                  v-model="disableUser"
                  style="margin-top: 0px"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>

                <v-checkbox
                  v-if="user.AgentAdminStatusCode == 'I'"
                  color="green"
                  label="Enable User Access?"
                  v-model="enableUser"
                  style="margin-top: 0px"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="isUpdate">
              <v-col>
                <v-text-field
                  ref="statusMsg"
                  v-model="statusMessageLocal"
                  label="Status Message"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="isUpdate">
              <v-col>
                <v-checkbox
                  color="green"
                  label="Re-Activate Salesforce License?"
                  v-model="ActivateSalesforceLicenseIndLocal"
                  style="margin-top: 0px"
                  :disabled="!isIAMAdmin"
                ></v-checkbox> </v-col
              ><v-col>
                <v-text-field
                  ref="lastSalesforceActivatedDate"
                  :value="LastSalesforceActivatedDateLocal | mmddyyyy"
                  label="Last Salesforce License Re-Activation Date"
                  outlined
                  placeholder="N/A"
                  readonly
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="firstName"
                  v-model.trim="firstNameLocal"
                  :rules="[() => !!firstNameLocal || 'First Name is required']"
                  label="First Name"
                  outlined
                  required
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="middleName"
                  v-model.trim="middleNameLocal"
                  label="Middle Name"
                  outlined
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="lastName"
                  v-model.trim="lastNameLocal"
                  :rules="[() => !!lastNameLocal || 'Last Name is required']"
                  label="Last Name"
                  outlined
                  required
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="address"
                  v-model.trim="addressLocal"
                  :rules="[
                    () => !!addressLocal || 'Address line one is required'
                  ]"
                  label="Address"
                  outlined
                  required
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  ref="address2"
                  v-model.trim="address2Local"
                  :rules="[]"
                  label="Address Line 2"
                  outlined
                  required
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="city"
                  v-model.trim="cityLocal"
                  :rules="[() => !!cityLocal || 'City is required']"
                  label="City"
                  outlined
                  dense
                  required
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  ref="state"
                  v-model="stateLocal"
                  :rules="[() => !!stateLocal || 'State/Province is required']"
                  :items="statesOrProvinces"
                  label="State"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                  v-if="countryLocal == 'United States of America'"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-autocomplete>
                <v-text-field
                  v-if="countryLocal != 'United States of America'"
                  ref="state"
                  v-model.trim="stateLocal"
                  :rules="[() => !!stateLocal || 'State/Province is required']"
                  label="State/Province"
                  outlined
                  dense
                  required
                  maxLength="50"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  ref="zip"
                  v-model.trim="zipLocal"
                  :rules="[() => !!zipLocal || 'ZIP/Postal Code is required']"
                  label="ZIP / Postal Code"
                  required
                  outlined
                  dense
                  maxLength="20"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-autocomplete
                  ref="country"
                  v-model="countryLocal"
                  :rules="[() => !!countryLocal || 'Country is required']"
                  :items="countries"
                  label="Country"
                  placeholder="Select..."
                  required
                  outlined
                  dense
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" class="removeTopAndBottomPadding">
                <v-text-field
                  ref="phone"
                  v-model.trim="phoneLocal"
                  :rules="[
                    () =>
                      !phoneLocal ||
                      /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                        phoneLocal
                      ) ||
                      'Please enter a valid phone number with area code.'
                  ]"
                  label="Home Phone Number"
                  outlined
                  dense
                  maxLength="30"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding">
                <v-text-field
                  v-show="!isUpdate"
                  ref="email"
                  v-model.trim="emailLocal"
                  :rules="[
                    () => !!emailLocal || 'E-mail is required.',
                    () =>
                      /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
                        emailLocal ? emailLocal.trim() : emailLocal
                      ) || 'E-mail must be valid'
                  ]"
                  label="E-Mail Address"
                  outlined
                  required
                  dense
                  maxLength="100"
                  :readonly="!isIAMAdmin"
                  :filled="!isIAMAdmin"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="removeTopAndBottomPadding">
              <v-col class="removeTopAndBottomPadding ">
                <v-radio-group
                  v-model="allIndicator"
                  label="Would you like to allow access to all of your agent numbers?"
                  row
                  dense
                  :readonly="!isIAMAdmin"
                >
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  :disabled="allIndicator || !isIAMAdmin"
                  v-model="agentNumberValues"
                  :items="possibleAgentNumbers"
                  :no-data-text="loading ? 'Loading...' : 'No data found.'"
                  :menu-props="{ maxHeight: '400' }"
                  item-text="text"
                  item-value="value"
                  label="Associated Agent Numbers"
                  style="z-index:999"
                  outlined
                  multiple
                  dense
                  hint="Select Agent Numbers for Access (Type to Search)"
                  persistent-hint
                  :search-input.sync="search"
                  @change="
                    search = '';
                    agentNumberValues = agentNumberValues.sort();
                  "
                ></v-autocomplete>

                <!-- @blur="agentNumberValues=agentNumberValues.sort()"
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h2 style="color: green">Permissions</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <v-checkbox
                      color="green"
                      label="Agent Hierarchy - Agent Data"
                      v-model="agentData"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>
                    <v-checkbox
                      color="green"
                      label="My Business - Policy Data"
                      v-model="policyData"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
                <br /><br />
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Case Management</h3>
                    <v-checkbox
                      color="green"
                      label="Add/Update Access"
                      v-model="cmAddUpdate"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <!-- <v-checkbox
                      color="green"
                      label="View Access"
                      v-model="cmView"
                    ></v-checkbox> -->
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Agent Tools</h3>
                    <v-checkbox
                      color="green"
                      label="Agent Appointments"
                      v-model="agentAppointments"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Agent Resources"
                      v-model="agentResources"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Automated Supply Order Form & AdCatalog"
                      v-model="automatedInstructions"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Do Not Call Search & Request Form"
                      v-model="doNotCallSearch"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Life Proposal System"
                      v-model="lifeProposalSystem"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Part A Deductible Waiver Program"
                      v-model="partADedWaiverProg"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card class="elevation-4" style="max-width: 300px">
                  <v-card-text>
                    <h3>Reports</h3>
                    <v-checkbox
                      color="green"
                      label="Commission Statements"
                      v-model="commissionStatements"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Pending Agency Report"
                      v-model="pendingAgencyReport"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>

                    <v-checkbox
                      color="green"
                      label="Production Report"
                      v-model="productionReport"
                      :disabled="!isIAMAdmin"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="$vuetify.breakpoint.smAndDown">
        <v-row class="littleDrop"> </v-row>

        <v-row v-if="isUpdate" class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="federationId"
              v-model="federationIdLocal"
              label="User ID"
              outlined
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="status"
              v-model="statusLocal"
              label="Admin User Status"
              outlined
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="activeStatusDate"
              :value="activeStatusDateLocal | mmddyyyy"
              label="Active Status Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="inActiveStatusDate"
              :value="inActiveStatusDateLocal | mmddyyyy"
              label="Inactive Status Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-checkbox
              v-if="
                user.AgentAdminStatusCode == 'A' ||
                  user.AgentAdminStatusCode == 'P' ||
                  user.AgentAdminStatusCode == 'F'
              "
              color="green"
              label="Disable User Access?"
              v-model="disableUser"
              style="margin-top: 0px"
              :disabled="!isIAMAdmin"
            ></v-checkbox>

            <v-checkbox
              v-if="user.AgentAdminStatusCode == 'I'"
              color="green"
              label="Enable User Access?"
              v-model="enableUser"
              style="margin-top: 0px"
              :disabled="!isIAMAdmin"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="statusMsg"
              v-model="statusMessageLocal"
              label="Status Message"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-checkbox
              color="green"
              label="Re-Activate Salesforce License?"
              v-model="ActivateSalesforceLicenseIndLocal"
              style="margin-top: 0px"
              :disabled="!isIAMAdmin"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="isUpdate">
          <v-col>
            <v-text-field
              ref="lastSalesforceActivatedDate"
              :value="LastSalesforceActivatedDateLocal | mmddyyyy"
              label="Last Salesforce License Re-Activation Date"
              outlined
              placeholder="N/A"
              readonly
              filled
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="firstName"
              v-model.trim="firstNameLocal"
              :rules="[() => !!firstNameLocal || 'First Name is required']"
              label="First Name"
              outlined
              required
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="middleName"
              v-model.trim="middleNameLocal"
              label="Middle Name"
              outlined
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="lastName"
              v-model.trim="lastNameLocal"
              :rules="[() => !!lastNameLocal || 'Last Name is required']"
              label="Last Name"
              outlined
              required
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="address"
              v-model.trim="addressLocal"
              :rules="[() => !!addressLocal || 'Address line one is required']"
              label="Address"
              outlined
              required
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              ref="address2"
              v-model.trim="address2Local"
              :rules="[]"
              label="Address Line 2"
              outlined
              required
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="city"
              v-model.trim="cityLocal"
              :rules="[() => !!cityLocal || 'City is required']"
              label="City"
              outlined
              dense
              required
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="state"
              v-model="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              :items="statesOrProvinces"
              label="State"
              placeholder="Select..."
              required
              outlined
              dense
              v-if="countryLocal == 'United States of America'"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-autocomplete>
            <v-text-field
              v-if="countryLocal != 'United States of America'"
              ref="state"
              v-model.trim="stateLocal"
              :rules="[() => !!stateLocal || 'State/Province is required']"
              label="State/Province"
              outlined
              dense
              required
              maxLength="50"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="zip"
              v-model.trim="zipLocal"
              :rules="[() => !!zipLocal || 'ZIP/Postal Code is required']"
              label="ZIP / Postal Code"
              required
              outlined
              dense
              maxLength="20"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-autocomplete
              ref="country"
              v-model="countryLocal"
              :rules="[() => !!countryLocal || 'Country is required']"
              :items="countries"
              label="Country"
              placeholder="Select..."
              required
              outlined
              dense
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              ref="phone"
              v-model.trim="phoneLocal"
              :rules="[
                () =>
                  !phoneLocal ||
                  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(
                    phoneLocal
                  ) ||
                  'Please enter a valid phone number with area code.'
              ]"
              label="Home Phone Number"
              outlined
              dense
              maxLength="30"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding">
            <v-text-field
              v-show="!isUpdate"
              ref="email"
              v-model.trim="emailLocal"
              :rules="[
                () => !!emailLocal || 'Primary e-mail address is required.'
              ]"
              label="E-Mail Address"
              outlined
              required
              dense
              maxLength="100"
              :readonly="!isIAMAdmin"
              :filled="!isIAMAdmin"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="removeTopAndBottomPadding">
          <v-col class="removeTopAndBottomPadding ">
            <v-radio-group
              v-model="allIndicator"
              label="Would you like to allow access to all of your agent numbers?"
              row
              dense
              :readonly="!isIAMAdmin"
            >
              <v-radio label="Yes" :value="true"></v-radio>
              <v-radio label="No" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              :disabled="allIndicator || !isIAMAdmin"
              v-model="agentNumberValues"
              :items="possibleAgentNumbers"
              :no-data-text="loading ? 'Loading...' : 'No data found.'"
              :menu-props="{ maxHeight: '400' }"
              item-text="text"
              item-value="value"
              label="Associated Agent Numbers"
              style="z-index:999"
              outlined
              multiple
              dense
              hint="Select Agent Numbers for Access (Type to Search)"
              persistent-hint
              :search-input.sync="search"
              @change="
                search = '';
                agentNumberValues = agentNumberValues.sort();
              "
            ></v-autocomplete>

            <!-- 
          @keydown="function(e){if (e.keyCode==16) shiftDown=true;}"
          @keyup="function(e){if (e.keyCode==16) shiftDown=false;}" -->
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <h2 style="color: green">Permissions</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <v-checkbox
                  color="green"
                  label="Agent Hierarchy - Agent Data"
                  v-model="agentData"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="My Business - Policy Data"
                  v-model="policyData"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Case Management</h3>
                <v-checkbox
                  color="green"
                  label="Add/Update Access"
                  v-model="cmAddUpdate"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="View Access"
                  v-model="cmView"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Agent Tools</h3>
                <v-checkbox
                  color="green"
                  label="Agent Appointments"
                  v-model="agentAppointments"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Agent Resources"
                  v-model="agentResources"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Automated Supply Order Form & AdCatalog"
                  v-model="automatedInstructions"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Do Not Call Search & Request Form"
                  v-model="doNotCallSearch"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Life Proposal System"
                  v-model="lifeProposalSystem"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>

                <v-checkbox
                  color="green"
                  label="Part A Deductible Waiver Program"
                  v-model="partADedWaiverProg"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-4">
              <v-card-text>
                <h3>Reports</h3>
                <v-checkbox
                  color="green"
                  label="Commission Statements"
                  v-model="commissionStatements"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Pending Agency Report"
                  v-model="pendingAgencyReport"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
                <v-checkbox
                  color="green"
                  label="Production Report"
                  v-model="productionReport"
                  :disabled="!isIAMAdmin"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="removeTopAndBottomPadding"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="menuBtn"
          color="#00558c"
          dark
          @click.native="cancelChanges"
          >Cancel</v-btn
        >

        <v-btn v-if="isIAMAdmin" color="green" class="menuBtn" dark @click="submit">Submit</v-btn>
      </v-card-actions>
      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <v-overlay :value="waitCircle"></v-overlay>
    </div>
    <br /><br /><br /><br />
  </span>
</template>
<script>
// import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP_GAP, IAMRoleName } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  props: {
    user: Object,
    mode: String
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobileCheck);
  },
  created() {
    if (!this.mode) {
      this.$router.push("/usermanagement");
    }

    this.isMobileCheck();

    window.addEventListener("resize", this.isMobileCheck);
  },
  mounted() {
    if (this.user && this.user != null) {
      this.federationIdLocal = this.user.FederationID;
      this.firstNameLocal = this.user.FirstName;
      this.middleNameLocal = this.user.MiddleName;
      this.lastNameLocal = this.user.LastName;
      this.addressLocal = this.user.AddressLine1;
      this.address2Local = this.user.AddressLine2;
      this.cityLocal = this.user.City;
      this.stateLocal = this.user.StateProvinceCode;
      this.zipLocal = this.user.PostalCode;
      this.phoneLocal = this.user.PhoneNum;
      this.emailLocal = this.user.Email;

      this.policyData = this.user.PolicyDataPermissionInd;
      this.agentData = this.user.AgentDataPermissionInd;
      this.cmView = this.user.CaseManagementViewPermissionInd;
      this.cmAddUpdate = this.user.CaseManagementAddUpdatePermissionInd;
      this.commissionStatements = this.user.CommissionStatementsPermissionInd;
      this.productionReport = this.user.ProductionReportPermissionInd;
      this.pendingAgencyReport = this.user.PendingAgencyReportPermissionInd;
      this.automatedAdCatalog = this.user.AutomatedSupplyOrderFormAdCatalogPermissionInd;
      this.automatedInstructions = this.user.AutomatedSupplyOrderFormInstructionsPermissionInd;
      // this.iGoEApp = this.user.iGOeAppPermissionInd;
      this.agentAppointments = this.user.AgentAppointmentsPermissionInd;
      this.lifeProposalSystem = this.user.LifeProposalSystemPermissionInd;
      this.partADedWaiverProg = this.user.PartADeductibleWaiverProgramPermissionInd;
      this.doNotCallSearch = this.user.DoNotCallSearchFormPermissionInd;
      this.doNotCallReq = this.user.DoNotCallRequestFormPermissionInd;
      this.agentResources = this.user.AgentResourcesPermissionInd;

      // this.policyData = true;
      // this.agentData = true;
      // this.cmView = true;
      // this.cmAddUpdate = true;
      // this.commissionStatements = true;
      // this.productionReport = true;
      // this.automatedAdCatalog = true;
      // this.automatedInstructions = true;
      this.iGoEApp = false;
      // this.agentAppointments = true;
      // this.lifeProposalSystem = true;
      // this.partADedWaiverProg = true;
      // this.doNotCallSearch = true;
      // this.doNotCallReq = true;
      // this.agentResources = true;

      this.ActivateSalesforceLicenseIndLocal = this.user.ActivateSalesforceLicenseInd;
      this.LastSalesforceActivatedDateLocal = this.user.LastSalesforceLicenseActivatedDate;

      this.statusLocal = this.Status;
      this.statusMessageLocal = this.user.AgentAdminStatusMessageText;
      this.activeStatusDateLocal = this.user.EmploymentDate;
      this.inActiveStatusDateLocal = this.user.TerminationDate;

      if (this.user.AgentNumPairs[0].AccessAssociatedAgentNum == "ALL") {
        this.allIndicator = true;
      } else {
        this.allIndicator = false;
      }
    }

    this.getCountries();
    this.getPossibleAgentNumberValues();

    if (this.user && this.user.AgentNumPairs) {
      for (let pair of this.user.AgentNumPairs) {
        if (pair.AccessAssociatedAgentNum != "ALL")
          this.agentNumberValues.push(
            pair.AccessAssociatedAgentNum +
              "|" +
              pair.AccessAssociatedGLCompanyID
          );
      }
    }
  },
  data: () => ({
    search: "",
    loading: false,
    shiftDown: false,
    allIndicator: true,
    possibleAgentNumberValues: [],
    possibleAgentNumbers: [],
    agentNumberValues: [],
    previousAgentNumberValues: [],
    shiftedAgentNumberValues: [],
    lastClickedAgentNumber: "",
    previousClickedAgentNumber: "",
    previousCountry: null,
    enableUser: false,
    disableUser: false,
    allCountries: [],
    emailRules: [
      v => !!v || "E-mail is required.",
      v =>
        /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
          v.trim()
        ) || "E-mail must be valid"
    ],
    waitCircle: false,
    countries: [],
    countriesArray: [],
    provinces: [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland",
      "Labrador",
      "Nova Scotia",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan"
    ],
    states: [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ],
    errorMessages: "",
    federationIdLocal: null,
    firstNameLocal: "",
    middleNameLocal: "",
    lastNameLocal: "",
    addressLocal: "",
    address2Local: "",
    cityLocal: "",
    stateLocal: "",
    zipLocal: "",
    countryLocal: "",
    phoneLocal: "",
    phoneExtLocal: "",
    emailLocal: "",
    statusLocal: "",
    statusMessageLocal: "",
    activeStatusDateLocal: null,
    inActiveStatusDateLocal: null,
    ActivateSalesforceLicenseIndLocal: null,
    LastSalesforceActivatedDateLocal: null,
    formHasErrors: false,
    policyData: true,
    agentData: true,
    agentResources: true,
    cmView: true,
    cmAddUpdate: true,
    iGoEApp: false,
    agentAppointments: true,
    lifeProposalSystem: true,
    partADedWaiverProg: true,
    doNotCallReq: true,
    doNotCallSearch: true,
    commissionStatements: true,
    automatedAdCatalog: true,
    productionReport: true,
    pendingAgencyReport: true,
    automatedInstructions: true
  }),

  computed: {
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "215";
    },

    isIAMAdmin() {
      return this.$store.state.userRoles && 
             this.$store.state.userRoles.indexOf(IAMRoleName) >= 0;
    },

    Status() {
      switch (this.user.AgentAdminStatusCode) {
        case "A":
          return "Active";
        case "I":
          return "Inactive";
        case "F":
          return "Failed";
        case "P":
          return "Pending";
        default:
          return "Unknown";
      }
    },
    isUpdate() {
      return this.mode == "Update";

      // if (
      //   this.user &&
      //   this.user.FederationID &&
      //   this.user.FederationID.trim() != ""
      // )
      //   return true;
      // return false;
    },
    statesOrProvinces() {
      let sts = this.states;

      return sts.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;

        return 0;
      });
    },

    form() {
      return {
        firstName: this.firstNameLocal,
        middleName: this.middleNameLocal,
        lastName: this.lastNameLocal,
        address: this.addressLocal,
        address2: this.address2Local,
        city: this.cityLocal,
        state: this.stateLocal,
        zip: this.zipLocal,
        country: this.countryLocal,
        phone: this.phoneLocal,
        email: this.emailLocal
      };
    }
  },

  watch: {
    agentNumberValues() {
      this.shiftedAgentNumberValues = [];
      this.shiftedAgentNumberValues.push(...this.agentNumberValues);

      if (
        this.agentNumberValues.length > this.previousAgentNumberValues.length
      ) {
        for (let anv of this.agentNumberValues) {
          let found = false;
          for (let panv of this.previousAgentNumberValues) {
            if (anv == panv) {
              found = true;
            }
            if (!found) this.lastClickedAgentNumber = anv;
            if (this.previousClickedAgentNumber == "")
              this.previousClickedAgentNumber = anv;
          }
        }
      } else {
        this.lastClickedAgentNumber = "";
        this.previousClickedAgentNumber = "";
      }

      if (
        this.shiftDown == true &&
        this.agentNumberValues.length > this.previousAgentNumberValues.length
      ) {
        let copy = false;

        for (let pan of this.possibleAgentNumbers) {
          if (copy) {
            if (this.shiftedAgentNumberValues.indexOf(pan.value) < 0)
              this.shiftedAgentNumberValues.push(pan.value);
          }

          if (this.lastClickedAgentNumber > this.previousClickedAgentNumber) {
            if (pan.value == this.previousClickedAgentNumber) {
              copy = true;
            }
            if (pan.value == this.lastClickedAgentNumber) {
              copy = false;
            }
          } else if (
            this.lastClickedAgentNumber < this.previousClickedAgentNumber
          ) {
            if (pan.value == this.previousClickedAgentNumber) {
              copy = false;
            }
            if (pan.value == this.lastClickedAgentNumber) {
              copy = true;
            }
          }
        }

        this.agentNumberValues = this.shiftedAgentNumberValues;
      }

      this.previousAgentNumberValues = this.agentNumberValues;
      this.previousClickedAgentNumber = this.lastClickedAgentNumber;
    },
    allIndicator() {
      if (this.allIndicator == true) {
        this.agentNumberValues = [];
        this.previousAgentNumberValues = [];
        this.lastClickedAgentNumber = "";
        this.previousClickedAgentNumber = "";
      }
    },
    name() {
      this.errorMessages = "";
    },
    countryLocal() {
      if (
        this.previousCountry != null &&
        this.previousCountry != this.countryLocal &&
        this.previousCountry == "United States of America"
      ) {
        this.stateLocal = "";
      }

      this.previousCountry = this.countryLocal;
    }
    // statesOrProvinces() {
    //   if (!this.statesOrProvinces.find((sp) => sp == this.stateLocal)) {
    //     this.stateLocal = undefined;
    //   }
    // },
  },

  methods: {
    cancelChanges() {
      // EventBus.$emit("closeCreateUser");
      this.$router.push({ name: "User Management" });
    },
    translateCountryToCode(countryName) {
      for (let country of this.allCountries) {
        if (country.CountryName == countryName) {
          return country.ISOCountryCode;
        }
      }

      return null;
    },
    translateCodeToCountry(code) {
      for (let country of this.allCountries) {
        if (country.ISOCountryCode == code) {
          return country.CountryName;
        }
      }
      return null;
    },

    getPossibleAgentNumberValues() {
      this.loading = true;
      HTTP_GAP.get("GetAgentNumberValues", {
        params: {
          AssociatedAgentTMKClientID: window.sessionStorage.getItem(
            "tmkClientId"
          )
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.possibleAgentNumberValues = results.data;

            for (let obj of results.data) {
              this.possibleAgentNumbers.push({
                text: obj.AgentNum,
                value: obj.AgentNum + "|" + obj.GLCompanyID
              });

              //+ " (" + obj.GLCompanyName + ")",
            }
          }

          this.loading = false;
        })
        .catch(e => {
          this.addToErrorLogs(
            "create-user.vue getPossibleAgentNumberValues",
            e
          );
          this.loading = false;
          this.$modal.show("errorModal");
        });
    },

    async getCountries() {
      this.countries = [];

      this.waitCircle = true;

      HTTP_GAP.get("countries", {})
        .then(response => {
          if (response.status == 200) {
            for (let country of response.data) {
              this.countries.push(country.CountryName);

              if (
                this.user &&
                country.ISOCountryCode == this.user.ISOCountryCode
              ) {
                this.user.CountryName = country.CountryName;
              }

              this.allCountries.push(country);
            }

            if (this.user) {
              this.countryLocal = this.user.ISOCountryCode
                ? this.translateCodeToCountry(this.user.ISOCountryCode)
                : "United States of America";

              if (!this.countryLocal)
                this.countryLocal = "United States of America";
            } else {
              this.countryLocal = "United States of America";
            }
          } else {
            this.addToErrorLogs(
              "create-user.vue getCountries",
              new Error("response status is " + response.status.toString())
            );
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.addToErrorLogs("create-user.vue getCountries", e);
          this.$modal.show("errorModal");
        });

      this.countries.sort((a, b) => {
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
      });
      this.waitCircle = false;
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    async submit() {
      this.waitCircle = true;
      this.formHasErrors = false;

      let valid = true;
      Object.keys(this.form).forEach(f => {
        if (
          f == "state" &&
          this.countryLocal == "United States of America" &&
          !this.statesOrProvinces.find(sp => sp == this.form[f])
        )
          valid = false;

        if (!this.form[f]) this.formHasErrors = true;

        if (!this.$refs[f].validate(true)) valid = false;
      });

      if (
        this.policyData == false &&
        this.agentData == false &&
        this.agentResources == false &&
        this.cmView == false &&
        this.cmAddUpdate == false &&
        this.iGoEApp == false &&
        this.agentAppointments == false &&
        this.lifeProposalSystem == false &&
        this.partADedWaiverProg == false &&
        this.doNotCallReq == false &&
        this.doNotCallSearch == false &&
        this.commissionStatements == false &&
        this.automatedAdCatalog == false &&
        this.productionReport == false &&
        this.pendingAgencyReport == false &&
        this.automatedInstructions == false
      ) {
        if (valid) {
          this.$modal.show("selectPermissionsModal");
        }

        valid = false;
      }

      if (!valid) {
        this.waitCircle = false;
        return;
      }

      if (valid && this.isUpdate) {
        let noChanges = false;

        if (
          this.firstNameLocal == this.user.FirstName &&
          this.middleNameLocal == this.user.MiddleName &&
          this.lastNameLocal == this.user.LastName &&
          this.addressLocal == this.user.AddressLine1 &&
          this.address2Local == this.user.AddressLine2 &&
          this.cityLocal == this.user.City &&
          this.stateLocal == this.user.StateProvinceCode &&
          this.zipLocal == this.user.PostalCode &&
          this.translateCountryToCode(this.form.country) ==
            this.user.ISOCountryCode &&
          this.phoneLocal == this.user.PhoneNum &&
          this.emailLocal == this.user.Email &&
          this.policyData == this.user.PolicyDataPermissionInd &&
          this.agentData == this.user.AgentDataPermissionInd &&
          this.cmView == this.user.CaseManagementViewPermissionInd &&
          this.cmAddUpdate == this.user.CaseManagementAddUpdatePermissionInd &&
          this.commissionStatements ==
            this.user.CommissionStatementsPermissionInd &&
          this.productionReport == this.user.ProductionReportPermissionInd &&
          this.pendingAgencyReport ==
            this.user.PendingAgencyReportPermissionInd &&
          this.automatedAdCatalog ==
            this.user.AutomatedSupplyOrderFormAdCatalogPermissionInd &&
          this.automatedInstructions ==
            this.user.AutomatedSupplyOrderFormInstructionsPermissionInd &&
          // this.iGoEApp == this.user.iGOeAppPermissionInd &&
          this.agentAppointments == this.user.AgentAppointmentsPermissionInd &&
          this.lifeProposalSystem ==
            this.user.LifeProposalSystemPermissionInd &&
          this.partADedWaiverProg ==
            this.user.PartADeductibleWaiverProgramPermissionInd &&
          this.doNotCallSearch == this.user.DoNotCallSearchFormPermissionInd &&
          this.doNotCallReq == this.user.DoNotCallRequestFormPermissionInd &&
          this.agentResources == this.user.AgentResourcesPermissionInd &&
          this.ActivateSalesforceLicenseIndLocal ==
            this.user.ActivateSalesforceLicenseInd &&
          !this.disableUser &&
          !this.enableUser
        ) {
          noChanges = true;
        }

        if (
          this.user.AgentNumPairs[0].AccessAssociatedAgentNum == "ALL" &&
          this.allIndicator == false
        ) {
          noChanges = false;
        } else if (
          this.allIndicator == true &&
          this.user.AgentNumPairs[0].AccessAssociatedAgentNum != "ALL"
        ) {
          noChanges = false;
        } else {
          for (let pair of this.user.AgentNumPairs) {
            let found = false;

            for (let val of this.agentNumberValues) {
              let agentNum = val.split("|")[0];
              let comp = val.split("|")[1];

              if (
                pair.AccessAssociatedAgentNum == agentNum &&
                pair.AccessAssociatedGLCompanyID == comp
              )
                found = true;
            }

            if (found == false) {
              noChanges = false;
            }
          }

          for (let val of this.agentNumberValues) {
            let found = false;

            let agentNum = val.split("|")[0];
            let comp = val.split("|")[1];

            for (let pair of this.user.AgentNumPairs) {
              if (
                pair.AccessAssociatedAgentNum == agentNum &&
                pair.AccessAssociatedGLCompanyID == comp
              )
                found = true;
            }

            if (found == false) {
              noChanges = false;
            }
          }
        }

        if (noChanges == true) {
          this.waitCircle = false;
          this.$modal.show("noChangesModal");
          return;
        }

        if (
          noChanges == false &&
          this.enableUser == false &&
          this.user.AgentAdminStatusCode == "I"
        ) {
          this.waitCircle = false;
          this.$modal.show("inactiveSaveModal");
          return;
        }
      }

      let curDate = new Date();

      if (valid) {
        let save = {};

        save.FederationID = this.isUpdate
          ? this.user.FederationID
          : this.form.email;
        save.FirstName = this.form.firstName;
        save.MiddleName = this.form.middleName;
        save.LastName = this.form.lastName;
        save.AgentAdminStatusCode = this.isUpdate
          ? this.user.AgentAdminStatusCode == "F" && this.disableUser
            ? "I"
            : this.user.AgentAdminStatusCode == "F"
            ? "P"
            : this.enableUser
            ? "P"
            : this.disableUser
            ? "I"
            : this.user.AgentAdminStatusCode
          : "P";
        save.AgentAdminStatusMessageText = this.isUpdate
          ? this.user.AgentAdminStatusCode == "F"
            ? null
            : this.disableUser || this.enableUser
            ? null
            : this.user.AgentAdminStatusMessageText
          : null;
        save.AssociatedAgentTMKClientID = window.sessionStorage.getItem(
          "tmkClientId"
        );
        save.TMKClientID = this.isUpdate
          ? this.user.AgentAdminStatusCode == "F"
            ? null
            : this.user.TMKClientID
          : null;
        save.Email = this.form.email;
        save.AddressLine1 = this.form.address;
        save.AddressLine2 = this.form.address2;
        save.City = this.form.city;
        save.StateProvinceCode = this.form.state;
        save.PostalCode = this.form.zip;
        save.ISOCountryCode = this.translateCountryToCode(this.form.country);
        save.PhoneNum = this.form.phone;
        save.EmploymentDate = this.isUpdate
          ? this.user.AgentAdminStatusCode == "F"
            ? null
            : this.enableUser
            ? null
            : this.user.EmploymentDate
          : null;
        save.TerminationDate = this.isUpdate
          ? this.disableUser
            ? curDate.toISOString()
            : this.user.TerminationDate
          : null;
        save.ActivateSalesforceLicenseInd = this.isUpdate
          ? this.ActivateSalesforceLicenseIndLocal
          : false;
        save.LastSalesforceLicenseActivatedDate = this.isUpdate
          ? this.user.LastSalesforceLicenseActivatedDate
          : null;
        save.PolicyDataPermissionInd = this.policyData;
        save.AgentDataPermissionInd = this.agentData;
        save.CaseManagementViewPermissionInd = this.cmAddUpdate;
        save.CaseManagementAddUpdatePermissionInd = this.cmAddUpdate;
        save.CommissionStatementsPermissionInd = this.commissionStatements;
        save.ProductionReportPermissionInd = this.productionReport;
        save.PendingAgencyReportPermissionInd = this.pendingAgencyReport;
        save.AutomatedSupplyOrderFormAdCatalogPermissionInd = this.automatedInstructions;
        save.AutomatedSupplyOrderFormInstructionsPermissionInd = this.automatedInstructions;
        save.iGOeAppPermissionInd = this.iGoEApp;
        save.AgentAppointmentsPermissionInd = this.agentAppointments;
        save.LifeProposalSystemPermissionInd = this.lifeProposalSystem;
        save.PartADeductibleWaiverProgramPermissionInd = this.partADedWaiverProg;
        save.DoNotCallSearchFormPermissionInd = this.doNotCallSearch;
        save.DoNotCallRequestFormPermissionInd = this.doNotCallSearch;
        save.AgentResourcesPermissionInd = this.agentResources;
        const userIdentifier = this.isIAMAdmin 
          ? "AMT-" + this.$store.getters.currentUser.username
          : "AMT-" + window.sessionStorage.getItem("tmkClientId");
        save.CreatedBy = userIdentifier;
        save.CreatedDate = this.isUpdate
          ? this.user.CreatedDate
          : curDate.toISOString();
        save.UpdatedBy = userIdentifier;
        save.UpdatedDate = curDate.toISOString();

        if (this.agentNumberValues.length == 0) {
          save.AllIndicator = true;
        } else save.AllIndicator = false;

        save.AgentNumPairs = [];

        for (let agentNumVal of this.agentNumberValues) {
          let agentNum = agentNumVal.split("|")[0];
          let comp = agentNumVal.split("|")[1];

          save.AgentNumPairs.push({
            AgentNum: agentNum,
            GLCompanyID: comp
          });
        }

        if (save.AgentAdminStatusCode == "P") {
          HTTP_GAP.post("CheckInactiveDups", save)
            .then(results => {
              if (results.status == 200) {
                let admins = results.data;
                let OK = true;

                if (admins && admins.length && !this.isUpdate) {
                  OK = false;
                  this.waitCircle = false;
                  this.$modal.show("insertDupErrorModal");
                  return;
                }

                if (OK) {
                  HTTP_GAP.post("CheckDups", save)
                    .then(results => {
                      if (results.status == 200) {
                        let agents = results.data;
                        let OK = true;

                        if (agents && agents.length) {
                          if (!this.isUpdate) {
                            OK = false;
                            this.waitCircle = false;
                            this.$modal.show("insertUpdateErrorModal");
                            return;
                          } else {
                            for (let agent of agents) {
                              if (
                                agent.AssociatedAgentTMKClientID !=
                                save.AssociatedAgentTMKClientID
                              ) {
                                OK = false;
                                this.waitCircle = false;
                                this.$modal.show("insertUpdateErrorModal");
                                return;
                              }
                            }
                          }
                        }

                        if (OK && !this.isUpdate) {
                          HTTP_GAP.post("CreateAgentAdmin", save)
                            .then(results => {
                              if (results.status == 200) {
                                this.waitCircle = false;
                                this.addToAuditLog('GAP', 'Created GAP admin user: ' + save.FederationID);
                                this.$modal.show("saveModal");
                              } else {
                                this.waitCircle = false;
                                this.$modal.show("errorModal");
                              }
                            })
                            .catch(e => {
                              this.waitCircle = false;
                              this.$modal.show("errorModal");
                              this.addToErrorLogs(
                                "create-user.vue submit CreateAgentAdmin 1",
                                e
                              );
                            });
                        } else if (OK && this.isUpdate) {
                          HTTP_GAP.post("UpdateAgentAdmin", save)
                            .then(results => {
                              if (results.status == 200) {
                                this.waitCircle = false;
                                this.addToAuditLog('GAP', 'Updated GAP admin user: ' + save.FederationID);
                                this.$modal.show("saveModal");
                              } else {
                                this.waitCircle = false;
                                this.$modal.show("errorModal");
                              }
                            })
                            .catch(e => {
                              this.waitCircle = false;
                              this.$modal.show("errorModal");
                              this.addToErrorLogs(
                                "create-user.vue submit UpdateAgentAdmin 1",
                                e
                              );
                            });
                        }
                      } else {
                        this.waitCircle = false;
                        this.$modal.show("errorModal");
                      }
                    })
                    .catch(e => {
                      this.waitCircle = false;
                      this.$modal.show("errorModal");
                      this.addToErrorLogs(
                        "create-user.vue submit CheckDups",
                        e
                      );
                    });
                }
              } else {
                this.waitCircle = false;
                this.$modal.show("errorModal");
              }
            })
            .catch(e => {
              this.waitCircle = false;
              this.$modal.show("errorModal");
              this.addToErrorLogs(
                "create-user.vue submit CheckInactiveDups",
                e
              );
            });
        } else {
          HTTP_GAP.post("UpdateAgentAdmin", save)
            .then(results => {
              if (results.status == 200) {
                if (this.disableUser) {
                  HTTP_GAP.get("disableUser", {
                    params: { userName: this.form.email }
                  })
                    .then(results => {
                      if (results.status == 200) {
                        this.waitCircle = false;
                        this.$modal.show("saveModal");
                      } else {
                        this.waitCircle = false;
                        this.$modal.show("cognitoErrorModal");
                      }
                    })
                    .catch(e => {
                      this.waitCircle = false;
                      this.$modal.show("cognitoErrorModal");
                      this.addToErrorLogs(
                        "create-user.vue submit disableUser",
                        e
                      );
                    });
                } else {
                  this.waitCircle = false;
                  this.$modal.show("saveModal");
                }
              } else {
                this.waitCircle = false;
                this.$modal.show("errorModal");
              }
            })
            .catch(e => {
              this.waitCircle = false;
              this.$modal.show("errorModal");
              this.addToErrorLogs(
                "create-user.vue submit UpdateAgentAdmin 2",
                e
              );
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.drop {
  margin-top: 100px;
}
.littleDrop {
  margin-top: 15px;
}

.addressTitle {
  color: green;
  font-size: 2rem;
  font-weight: normal;
  margin-left: 20px;
  padding-top: 20px;
}
.addressTitleXS {
  color: green;
  font-size: 1.5rem;
  font-weight: normal;
  margin-left: 20px;
  padding-top: 20px;
}
.removeTopAndBottomPadding {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.waitCircle {
  z-index: 20;
  position: absolute;
  top: 50%;
  left: 48%;
}
</style>
